import {Injectable} from '@angular/core';
import {Const} from '../const/const';
import {Observable} from 'rxjs';
import {City} from '../models/city.model';
import {FieldWork} from '../models/field-work.model';
import {HttpClient} from '@angular/common/http';
import {Country} from '../models/country.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
    constructor (private http: HttpClient) {}

    getCities(): Observable<City[]> {
        return this.http.get<City[]>(Const.baseAPI + '/get-cities');
    }

    getFieldWorks(): Observable<FieldWork[]> {
        return this.http.get<FieldWork[]>(Const.baseAPI + '/get-field-works');
    }

    getCountries(): Observable<Country[]> {
        return this.http.get<Country[]>(Const.baseAPI + '/get-countries');
    }

}
